import { render } from "./DrawerContentsHeader.vue?vue&type=template&id=86759240"
import script from "./DrawerContentsHeader.vue?vue&type=script&lang=js"
export * from "./DrawerContentsHeader.vue?vue&type=script&lang=js"

import "./DrawerContentsHeader.vue?vue&type=style&index=0&id=86759240&lang=scss"

import exportComponent from "/builds/lindner/lindner-factorytour-frontend-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__